import {
    getData,
    postData,
    deleteData
} from './Services'

export const getArtMedidasPanel = async (artId,searchTerm, page, perPage) => {
    let queryParams = [];
    if (artId) {
        queryParams.push(`art_Id=${encodeURIComponent(artId || '')}`);
    }
    if (searchTerm) {
        queryParams.push(`med_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';

    return await getData("/articulosmedidas", queryString);
};

export const getArtMedidaById = async (id) => {
    const res = await getData(`/articulosmedidas/${id}`)
    return res
}

export const postArtMedida = async (body) => {
    const res = await postData('/articulosmedidas', body)
    return res
}

export const deleteArtMedida = async (id) => {
    const res = await deleteData(`/articulosmedidas/${id}`)
    return res
}